"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isFormMounted;
var _find = _interopRequireDefault(require("lodash/find"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function isFormMounted(form) {
  return form && !!(0, _find["default"])(form.registeredFields, function (_ref) {
    var count = _ref.count;
    return !!count;
  });
}